import React, { Component } from 'react';
import moment from 'moment';
import {
  DL_AD_BANNER,
  DL_OFFERS,
  DL_SHOPS,
  DOM_INTERSTITIAL_PAGE,
  INTERSTITIAL_TIMEOUT,
} from '../../../../lib/constants';
import {
  makeExternalUrl,
  trackAnalytics,
  extensionRedirect,
} from '../../../../lib/utils';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import MilesOffer from '../shared/MilesOffer';
import { saveInterrupt, removeInterruptById } from '../../../../lib/user';
import {
  showInterruptMessage,
} from '../../../../lib/helpers';

import {
  addObjToDataLayer,
  dataLayerIdGenerator,
} from '../../../../lib/dataLayerUtils';
import ShopsLogoContainer from '../shared/ShopsLogoContainer';
import DotsLoader from '../DotsLoader/DotsLoader';
import {
  ActionContainer,
  DesktopExitHelpTextH2,
  DesktopExitTextH1,
  InterstitialButton,
  DesktopLogoImgContainer,
  DesktopShopLogoImgContainer,
  GenericImg,
  InterstitialContainerDiv,
  MobileExitHelpTextH2,
  MobileExitTextH1,
  MobileLogoImgContainer,
  MobileShopLogoImgContainer,
} from './interstitialPage.styles';
import InterstitialModal from './interstitialModal/InterstitialModal';

class InterstitialPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInterruptMessage: showInterruptMessage(this.props),
      shouldShowInformationAgain: false,
    };
    this.redirectToExternalLink = this.redirectToExternalLink.bind(this);
  }

  componentDidMount() {
    const shopData = Object.assign({}, this.props.shopData);
    const offerData = Object.assign({}, this.props.offerData);
    const adData = Object.assign({}, this.props.adData);

    const shopSlug = shopData && shopData.slug ? shopData.slug : '';
    const offerSlug = offerData && offerData.slug ? offerData.slug : '';
    const adSlug = adData && adData.slug ? adData.slug : '';

    // Add shop data to dataLayer
    shopData.dataLayerId = dataLayerIdGenerator(DL_SHOPS, shopSlug);
    addObjToDataLayer(shopData, 'redirectShop');

    // Add offer data to dataLayer
    offerData.dataLayerId = dataLayerIdGenerator(DL_OFFERS, offerSlug);
    addObjToDataLayer(offerData, 'redirectOffer');

    // Add ad data to dataLayer
    adData.dataLayerId = dataLayerIdGenerator(DL_AD_BANNER, adSlug);
    addObjToDataLayer(adData, 'redirectAd');

    if (!this.state.showInterruptMessage) {
      setTimeout(() => this.redirectToExternalLink(), INTERSTITIAL_TIMEOUT);
    }

    // Reload opener if user just logged in
    const targetWindow = window.opener;

    if (
      this.props.auth &&
      targetWindow &&
      targetWindow.location &&
      targetWindow.location.reload
    ) {
      targetWindow.location.reload();
    }
  }

  componentDidUpdate(_, previousState) {
    if (
      previousState.showInterruptMessage !== this.state.showInterruptMessage
    ) {
      setTimeout(() => this.redirectToExternalLink(), INTERSTITIAL_TIMEOUT);
    }
  }

  redirectToExternalLink() {
    const { shopData, redirectUri, environment } = this.props;
    const brokerName = shopData && shopData.broker && shopData.broker.name;

    // Drop cookie to notify browser extension
    extensionRedirect(shopData.slug, environment);

    // Commission Junction specific redirect method
    if (typeof cj !== 'undefined' && brokerName === 'CJ Affiliate') {
      cj.navigate(redirectUri);
    } else {
      window.location.assign(redirectUri);
    }
  }

  render() {
    const { interstitialData, shopData, locale, redirectUrl } = this.props;

    const {
      slug,
      tags,
      shopsLogoText,
      exitText,
      exitHelpText,
      exitButtonText,
    } = interstitialData;

    const {
      id,
      displayName,
      mediumImageUrl,
      mediumImageAltText,
      baseMiles,
      amountPerBaseMiles,
      multiplier,
      siteWideMultiplier,
      config: {
        singularMilesText = '',
        pluralMilesText = '',
        singularFlatRateMilesText = '',
        pluralFlatRateMilesText = '',
        milesBadgeText = '',
        interruptVisibilityMessage = '',
        interruptContinueButtonText = '',
        interruptHeaderText = '',
      },
      importantInformation,
    } = shopData;

    const resolvedShopLogoUrl = makeExternalUrl(mediumImageUrl);

    const track = trackAnalytics(
      DOM_INTERSTITIAL_PAGE,
      slug,
      redirectUrl,
      tags
    );

    // Click handler for interrupt preference checkbox
    const toggleInterrupt = async () => {
      if (this.state.shouldShowInformationAgain) {
        await removeInterruptById(id);
      } else {
        await saveInterrupt(id, moment().toISOString());
      }
      this.setState({
        shouldShowInformationAgain: !this.state.shouldShowInformationAgain,
      });
    };

    // Click handler for modal actions
    const resumeJourney = async () => {
      this.setState({ showInterruptMessage: false });
      setTimeout(() => this.redirectToExternalLink(), INTERSTITIAL_TIMEOUT);
    }

    const ActionButtons = (
      <ActionContainer>
        <div className="action-checkbox-container">
          <input
            type="checkbox"
            name="checkall"
            id="checkall"
            checked={this.state.shouldShowInformationAgain}
            onChange={toggleInterrupt}
          />
          <label htmlFor="checkall">{interruptVisibilityMessage}</label>
        </div>
        <div className="action-buttons-container">
          <InterstitialButton
            variant="primary"
            size="medium"
            id={track.dataTrackingId}
            dataTrackingId={track.dataTrackingId}
            dataTrack={track.dataTrack}
            onClick={resumeJourney}
            buttonText={interruptContinueButtonText.replace('%s', displayName)}
          />
        </div>
      </ActionContainer>
    );

    const desktopInterstitialPage = (
      <InterstitialContainerDiv>
        <DesktopLogoImgContainer>
          <ShopsLogoContainer
            shopsLogoNavSlot={{ text: shopsLogoText }}
            size="large"
            locale={locale}
          />
        </DesktopLogoImgContainer>

        <DesktopExitTextH1>
          {' '}
          {exitText}
          {displayName}
        </DesktopExitTextH1>

        <DesktopExitHelpTextH2>{exitHelpText}</DesktopExitHelpTextH2>

        <DesktopShopLogoImgContainer>
          <GenericImg src={resolvedShopLogoUrl} alt={mediumImageAltText} />
        </DesktopShopLogoImgContainer>

        <InterstitialModal
          actionButtons={ActionButtons}
          showModal={this.state.showInterruptMessage}
          closeHandler={resumeJourney}
        >
          <h1 className="modal-header-text">{interruptHeaderText}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: importantInformation,
            }}
          />
        </InterstitialModal>
        <MilesOffer
          className={'interstitial'}
          multiplier={multiplier}
          siteWideMultiplier={siteWideMultiplier}
          baseMiles={baseMiles}
          amountPerBaseMiles={amountPerBaseMiles}
          singularMilesText={singularMilesText}
          pluralMilesText={pluralMilesText}
          singularFlatRateMilesText={singularFlatRateMilesText}
          pluralFlatRateMilesText={pluralFlatRateMilesText}
          milesBadgeText={milesBadgeText}
          locale={locale}
          size="2xl"
        />
        <DotsLoader />

        <InterstitialButton
          variant="primary"
          size="medium"
          gutter={9}
          id={track.dataTrackingId}
          data-track-id={track.dataTrackingId}
          data-track-click={track.dataTrack}
          onClick={this.redirectToExternalLink}
          buttonText={exitButtonText}
        />
      </InterstitialContainerDiv>
    );

    const mobileInterstitialPage = (
      <InterstitialContainerDiv>
        <MobileLogoImgContainer>
          <ShopsLogoContainer
            airmilesLogoNavSlot={{}}
            shopsLogoNavSlot={{ text: shopsLogoText }}
            logoTheme="light-bg"
          />
        </MobileLogoImgContainer>

        <MobileExitTextH1>
          {exitText}
          {displayName}
        </MobileExitTextH1>

        <MobileExitHelpTextH2>{exitHelpText}</MobileExitHelpTextH2>

        <MobileShopLogoImgContainer>
          <GenericImg src={resolvedShopLogoUrl} alt={mediumImageAltText} />
        </MobileShopLogoImgContainer>

        <InterstitialModal
          actionButtons={ActionButtons}
          showModal={this.state.showInterruptMessage}
          closeHandler={resumeJourney}
        >
          <h1 className="modal-header-text">{interruptHeaderText}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: importantInformation,
            }}
          />
        </InterstitialModal>
        <MilesOffer
          className={'interstitial'}
          multiplier={multiplier}
          siteWideMultiplier={siteWideMultiplier}
          baseMiles={baseMiles}
          amountPerBaseMiles={amountPerBaseMiles}
          singularMilesText={singularMilesText}
          pluralMilesText={pluralMilesText}
          singularFlatRateMilesText={singularFlatRateMilesText}
          pluralFlatRateMilesText={pluralFlatRateMilesText}
          milesBadgeText={milesBadgeText}
          locale={locale}
        />
        <DotsLoader />

        <InterstitialButton
          variant="primary"
          size="medium"
          gutter={6}
          id={track.dataTrackingId}
          data-track-id={track.dataTrackingId}
          data-track-click={track.dataTrack}
          onClick={this.redirectToExternalLink}
          buttonText={exitButtonText}
        />
      </InterstitialContainerDiv>
    );

    const renderComp = (
      <MaxWidthLayout>
        <MediaQueryHelper
          desktopChildren={desktopInterstitialPage}
          mobileChildren={mobileInterstitialPage}
        />
      </MaxWidthLayout>
    );
    return renderComp;
  }
}

export default InterstitialPage;
